import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '2rem' }} className="page-enter">
    <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🏙️</div>
    <h1 style={{ fontFamily: 'var(--ff-nepali)', fontSize: '2rem', fontWeight: 700, color: 'var(--gray-900)', marginBottom: '0.5rem' }}>
      पृष्ठ फेला परेन
    </h1>
    <p style={{ color: 'var(--gray-400)', marginBottom: '2rem', fontFamily: 'var(--ff-nepali)' }}>
      The page you are looking for does not exist.
    </p>
    <Link to="/" className="btn btn-primary">← Back to Home</Link>
  </div>
);

export default NotFound;
